export enum JobType {
    Wms = 1,
}
